import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';
import type { ServiceLevelsState, ProviderServiceLevels } from './service-levels.types';
import type { RootState } from 'store/root-state';

export const selectData = (state: ServiceLevelsState | null | undefined): ProviderServiceLevels[] =>
  state ?? (emptyArray as ProviderServiceLevels[]);

export const selectServiceLevelsData = (state: RootState) => selectData(get(state, 'serviceLevels') as ServiceLevelsState);
